import StudentInfo from "./src/main";

/* istanbul ignore next */
StudentInfo.install = function (Vue) {
  Vue.component(StudentInfo.name, StudentInfo);
};

export default StudentInfo;
